<template>
  <div class="menu">
      <div class="nav-items">
        <ul class="menu-items">
          <MenuItemFav />
          <MenuItem :icon-name="zoom ?  'icon-minify' : 'icon-magnify'" @click="toggleZoom" title="Zoom" />
          <MenuItem :icon-name="fullscreen ? 'icon-exit-full-screen' : 'icon-enter-full-screen'" @click="toggleFullscreen" :title="fullscreen ? 'Avlsutt fullskjerm' : 'Åpne i fullskjerm'" />
          <MenuItem :icon-name="spread ? 'icon-spread' : 'icon-page-right'" @click="toggleSpread" :title="spread ? 'Vis enkeltsider' : 'Vis oppslag'" />
          <MenuItem icon-name="icon-backward" title="Forrige side" class="navigation" @click="goToPreviousPage" />
          <MenuItem icon-name="icon-forward" title="Neste side" class="navigation" @click="goToNextPage" />
          <Pagination />
        </ul>
      </div>
  </div>
</template>

<script>
import MenuItem from '@/components/MenuItem'
import MenuItemFav from './MenuItemFav'
import MenuItemSettings from './MenuItemSettings'
import Pagination from './Pagination'
import { mapActions, mapGetters } from 'vuex'

export default {
  methods: {
    ...mapActions([
      'goToNextPage',
      'goToPreviousPage',
      'toggleZoom',
      'setSpread',
      'enterFullscreen',
      'exitFullscreen'
    ]),
    toggleSpread () {
      this.setSpread(!this.spread)
    },
    toggleFullscreen () {
      if (this.fullscreen) {
        this.exitFullscreen()
      } else {
        this.enterFullscreen()
      }
    }

  },
  computed: {
    ...mapGetters([
      'fullscreen',
      'zoom',
      'spread'
    ])
  },
  components: {
    MenuItem,
    MenuItemFav,
    MenuItemSettings,
    Pagination
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MenuRight.vue